import React, { useEffect, useState } from 'react';
import IPageProps from '../../interfaces/page';
import TopNavPage1 from '../topNav1';
import FooterPage from '../footer';
import { handleLink } from '../../modules/utils';
import ApplyFunctionBar from './component/applyFunctionBar';
import { IGroupInfo, IGroupStudent } from '../../interfaces/EpModal';
import { getDrStudentByGroup, getGroupListPass } from '../../services/EP/EPApplyGroupService';
import { Export2Word, ReacherArPictureName_before, currentClass, downloadImage, formatDate, formatDateTime, loadCtrlAndDisable, modeGlobal, replaceNewline } from './tool/helper';
import { checkFileExists } from '../../services/DrFileService';
import AllOpinion from './component/allOpinion';
// import { useControlCheck } from './HOC/withControlCheck';
// import NoEntry from './tool/NoEntry';

export interface StudentDisplay {
    ApplyName: string;
    ApplyNo: string;
    ApplyTitle: string;
    GroupName: string;
    GroupNo: string;
    SchoolName: string;
    StuName: string;
    StuNo: string;
    TeaName: string;
    TeaNo: string;
    TeaTitle: string;
    Team: {
        TStuName: string;
        TStuNo: string;
        checked: boolean;
    }[];
    Teachers: {
        TeaNo: string;
        TeaName: string;
        TeaTitle: string;
    }[];
}

// 決賽評審頁面
const EpJudgeFinal: React.FunctionComponent<IPageProps> = () => {
    const [groupDataList, setGroupDataList] = useState<IGroupInfo[]>([]);
    /** 目前選得隊伍 */
    const [selectedGroup, setSelectedGroup] = useState<IGroupInfo>();
    /** 目前選擇的隊伍明細 */
    const [currentGroupStudentList, setCurrentGroupStudentList] = useState<IGroupStudent[]>([]);
    /** 決賽簡報檔案是否存在 */
    const [isPptExist, setIsPptExist] = useState(false);

    useEffect(() => {
        // loadCtrlAndDisable(sessionStorage.getItem('role') || 'guest', '專題探究');
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            let groupList = await fetchDataGroup();
            setSelectedGroup(groupList[0]);
        };
        fetchData();
        if (selectedGroup) {
            fetchDataGroupStudent(selectedGroup.GroupNo);
        }

        // 確保下拉選單不被隱藏
        setTimeout(() => {
            const dropdownElements = document.querySelectorAll('.dropdown-keep, .dropdown-keep .btn');
            dropdownElements.forEach(el => {
                if (el instanceof HTMLElement) {
                    el.style.display = '';
                    el.style.pointerEvents = '';
                    el.style.opacity = '';
                    if (el instanceof HTMLButtonElement) {
                        el.disabled = false;
                    }
                }
            });
        }, 100);
    }, []);

    useEffect(() => {
        // 檢查決賽簡報檔案
        checkPptFileExists();
    }, [selectedGroup]);

    const fetchDataGroupStudent = async (groupNo: string) => {
        /**取得學生資料 */
        let groupStudentList = (await getDrStudentByGroup(groupNo)) as IGroupStudent[];
        setCurrentGroupStudentList(groupStudentList);
    };

    /** 檢查決賽簡報檔案是否存在 */
    const checkPptFileExists = async () => {
        if (selectedGroup?.GroupNo) {
            try {
                const rsp = await checkFileExists(`/uploads/upload${currentClass}/${selectedGroup.GroupNo}`, 'report.pptx', "");
                if (rsp === '檔案已存在.') {
                    setIsPptExist(true);
                } else {
                    setIsPptExist(false);
                }
            } catch (error) {
                console.error('檢查簡報檔案失敗:', error);
                setIsPptExist(false);
            }
        }
    };

    /**  取決賽資料 - 使用跟首頁決賽名單相同的資料來源 */
    const fetchDataGroup = async (): Promise<IGroupInfo[]> => {
        try {
            const urlParams = new URLSearchParams(window.location.search);
            const finalGroupFromUrl = urlParams.get('finalGroup') || '';

            console.log('決賽評審 - 開始獲取資料...');

            // 使用與 epMain.tsx 完全相同的邏輯
            const fetchResult = await getGroupListPass() as any[];
            console.log('決賽評審 - API回傳資料:', fetchResult);

            // 篩選決賽名單 (FlagRevOk = 1) - 與 epMain.tsx 相同邏輯
            let finalistData = fetchResult.filter((item: any) =>
                item.FlagRevOk == '1' &&
                !item.GroupNo?.includes('test') &&
                !item.GroupNo?.includes('Test')
            );

            // 如果有指定分組，進一步篩選 - 只使用 Type 欄位
            if (finalGroupFromUrl && finalGroupFromUrl.trim().toLowerCase() !== 'all') {
                finalistData = finalistData.filter((item: any) => {
                    // 只使用 Type 欄位進行篩選
                    const itemType = item.Type || item.type || '';

                    return itemType === finalGroupFromUrl ||
                        itemType.includes(finalGroupFromUrl) ||
                        finalGroupFromUrl.includes(itemType);
                });
            }

            // 按 FinalOrder 排序 - 與 epMain.tsx 相同邏輯
            finalistData.sort((a: any, b: any) => {
                const orderA = parseInt(a.FinalOrder) || 999;
                const orderB = parseInt(b.FinalOrder) || 999;
                return orderA - orderB;
            });

            // 轉換為IGroupInfo格式，並保留 FinalOrder
            const GroupDataList: IGroupInfo[] = finalistData.map((item: any) => ({
                uid: item.uid || 0,
                ApplyNo: item.ApplyNo || '',
                Class: currentClass,
                GroupNo: item.GroupNo || '',
                Groupname: item.GroupName || '',
                Schoolname: item.SchoolName || '',
                SchoolFull: item.SchoolFull || item.SchoolName || '',
                Type: item.Type || item.type || '',
                FlagOk: item.FlagOk || false,
                FlagRevOK: item.FlagRevOk || '0',
                UploadDate: item.UploadDate || '',
                PptDate: item.PptDate || '',
                CompLearn: item.CompLearn || '',
                IsEnterFinal: true, // 決賽名單都是進入決賽的
                Remark: item.Remark || '',
                teacher1: '',
                teacher2: '',
                FinalOrder: item.FinalOrder // 保留決賽順序
            } as IGroupInfo & { FinalOrder: string }));

            console.log('決賽評審 - 原始資料筆數:', fetchResult.length);
            console.log('決賽評審 - 篩選後決賽資料筆數:', finalistData.length);
            console.log('決賽評審 - 指定分組:', finalGroupFromUrl);
            console.log('決賽評審 - 最終資料:', GroupDataList);

            setGroupDataList(GroupDataList);
            return GroupDataList;
        } catch (error) {
            console.error('決賽評審 - 獲取資料失敗:', error);
            setGroupDataList([]);
            return [];
        }
    };

    // const homePage = '專題探究';
    // 決賽評審頁面開放給所有人使用，不做權限限制
    // const isView = useControlCheck(homePage);
    // const isView = true;

    return (
        <>
            <TopNavPage1 />
            <div className="section pt-3">
                <div className="container px-3 px-md-4">
                    <div className="d-flex align-items-center justify-content-between flex-column flex-lg-row">
                        <h5 className="title mb-3 me-3">專題探究競賽 - 決賽評審</h5>
                    </div>
                    <div className="text-center h5 mt-4">
                        決賽評審
                        {(() => {
                            const finalGroup = new URLSearchParams(window.location.search).get('finalGroup');
                            if (finalGroup && finalGroup.toLowerCase() !== 'all') {
                                return ` - ${finalGroup}`;
                            }
                            return '';
                        })()}
                    </div>
                    <div className="dropdown exclude dropdown-keep" style={{ width: 'fit-content' }}>
                        <button
                            className="btn text-second bg-second dropdown-toggle  exclude mb-0"
                            type="button"
                            id="dropdownMenuButton"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            style={{ minWidth: '250px' }}
                        >
                            {selectedGroup ? (
                                <span>
                                    <span className="me-2" style={{ color: '#78B9B5', fontSize: '16px', fontWeight: 'bold' }}>
                                        {(selectedGroup as any)?.FinalOrder || '?'}.
                                    </span>
                                    {selectedGroup.Groupname}{selectedGroup.Type}
                                </span>
                            ) : (
                                '選擇隊伍'
                            )}
                        </button>
                        <ul className="dropdown-menu px-2 py-3" aria-labelledby="dropdownMenuButton" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                            {groupDataList.map((group, index) => {
                                const finalOrder = (group as any)?.FinalOrder || (index + 1);

                                return (
                                    <li key={index}>
                                        <a className="dropdown-item d-flex align-items-center"
                                            href="#"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                console.log('選擇隊伍:', group);
                                                setSelectedGroup(group);
                                            }}
                                            style={{ cursor: 'pointer', textDecoration: 'none' }}>
                                            <span className="badge me-2" style={{ minWidth: '50px', color: '#78B9B5', fontSize: '16px', fontWeight: 'bold', borderBottomLeftRadius: '10px' }}>
                                                {finalOrder}.
                                            </span>
                                            <div>
                                                <div className="fw-bold">{group.GroupNo}</div>
                                                <small className="text-muted">{group.Groupname}</small>
                                            </div>
                                        </a>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>

                    {groupDataList.length === 0 && (
                        <div className="alert alert-info mt-3">
                            <i className="fas fa-info-circle me-2"></i>
                            {(() => {
                                const finalGroup = new URLSearchParams(window.location.search).get('finalGroup');
                                if (finalGroup && finalGroup.toLowerCase() !== 'all') {
                                    return `「${finalGroup}」分組目前沒有決賽隊伍`;
                                }
                                return '目前沒有決賽隊伍';
                            })()}
                        </div>
                    )}

                    <div id="title-info" hidden>
                        {selectedGroup?.Type} - {selectedGroup?.Groupname}({selectedGroup?.GroupNo})
                    </div>

                    {selectedGroup?.GroupNo ? (
                        <div className="mt-4">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-header">
                                            <h6 className="mb-0 text-second fw-bolder">隊伍資訊</h6>
                                        </div>
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <p>
                                                        <strong>決賽順序：</strong>
                                                        <span className="badge ms-2" style={{ color: '#78B9B5', fontSize: '16px', fontWeight: 'bold', backgroundColor: '#f8f9fa' }}>
                                                            {(selectedGroup as any)?.FinalOrder || '未設定'}
                                                        </span>
                                                    </p>
                                                    <p><strong>隊伍編號：</strong>{selectedGroup.GroupNo}</p>
                                                    <p><strong>隊伍名稱：</strong>{selectedGroup.Groupname}</p>
                                                    <p><strong>學校：</strong>{selectedGroup.Schoolname}</p>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="text-end">
                                                        <h6 className="mb-3">決賽簡報</h6>
                                                    </div>
                                                    {isPptExist ?
                                                        (<>
                                                            <a className="btn text-second bg-second" href={`/uploads/upload${currentClass}/${selectedGroup.GroupNo}/report.pptx`} download="報告簡報">
                                                                決賽簡報檔
                                                            </a>
                                                        </>
                                                        )
                                                        : (<>簡報未上傳</>)}

                                                </div>
                                            </div>

                                            {currentGroupStudentList.length > 0 && (
                                                <div className="mt-3">
                                                    <h6>隊員名單：</h6>
                                                    <ul className="list-group">
                                                        {currentGroupStudentList.map((student, index) => (
                                                            <li key={index} className="list-group-item d-flex justify-content-between">
                                                                <span>{student.StuName}</span>
                                                                <span className="text-muted">{student.StuGrade}年級</span>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <AllOpinion propClassName={currentClass} propGroupNo={selectedGroup.GroupNo} hideAllOpinion={true} />
                        </div>
                    ) : (
                        <div className="mt-4">
                            <div className="alert alert-warning">
                                請選擇要評審的隊伍
                            </div>
                        </div>
                    )}

                    <div className="pt-3 mt-4"></div>
                </div>
            </div>
            <FooterPage />

            {/* 教學模態框 */}
            <div className="modal fade" id="teach1" tabIndex={-1} role="dialog" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered" role="document" style={{ maxWidth: '720px' }}>
                    <div className="modal-content mx-3">
                        <div className="modal-header">
                            <h5 className="modal-title">決賽評審說明</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true" className="text-dark" style={{ fontSize: '36px', lineHeight: '12px' }}>
                                    &times;
                                </span>
                            </button>
                        </div>
                        <div className="modal-body text-center pb-3 px-0" style={{ overflowY: 'auto' }}>
                            <div className="p-3">
                                <h6>決賽評審流程</h6>
                                <p>1. 選擇要評審的決賽隊伍</p>
                                <p>2. 查看隊伍的專題探究內容</p>
                                <p>3. 進行評分和意見回饋</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default EpJudgeFinal; 